import { Stack } from '@mantine/core';
import { SwapPanel } from './SwapPanel';

export function SwapPage() {
  return (
    <Stack gap={40}>
      <SwapPanel />
    </Stack>
  );
}
